import { render, staticRenderFns } from "./AlertsOverview.vue?vue&type=template&id=69e8c795&"
import script from "./AlertsOverview.vue?vue&type=script&lang=ts&"
export * from "./AlertsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports